module.exports = __webpack_public_path__ + "img/DerTagAnDemFloydKam.22ef2264.svg";